import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faQrcode, faArrowCircleUp, faUsers, faUniversity, faBuilding, faCalendarAlt,
} from '@fortawesome/free-solid-svg-icons';
import { faWeixin, faQq } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import './style/ele-theme/theme/index.css';
import animate from 'animate.css'
import Axios from 'axios';
import {axiosConfig} from '@/config';
import dayjs from 'dayjs';

import {createRouter} from '@/router';


library.add(faQrcode, faWeixin, faQq, faArrowCircleUp, faUsers, faUniversity, faBuilding, faCalendarAlt);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(animate);

require('./icons/index')

Axios.defaults = {
  ...Axios.defaults,
  ...axiosConfig
}

Vue.filter('introduceOrContent', function (item) {
  if(item.introduce && item.introduce.length > 0) {
    return item.introduce
  } else {
    return item.content
  }
})
Vue.filter('removeTagAndCutTop', function (str) {
  return str.replace(/<[^>]+>/g, '').substring(0, 150)
})
Vue.filter('transHtmlEntity', function (str) {
  const elem = document.createElement('div')
  elem.innerHTML = str
  return (elem.innerText || elem.textContent).trim()
})
Vue.filter('transDateFormatToYMD', function(str) {
  return dayjs(str).format('YYYY-MM-DD')
})


const router = createRouter()

new Vue({
  el: '#app',
  router,
  render: (h) => h(App),
});
